webpackJsonp([55],{

/***/ "H4F6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-invoice-history-table_c639260bb12d8940e451298a5e8733b4.html";

/***/ }),

/***/ "c6SK":
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var SubscriptionInvoiceHistoryTable = (function () {
    function SubscriptionInvoiceHistoryTable() {
        this.invoicesList = this.invoicesList.map(function (invoice) {
            var status = invoice.status === 'SUCCESS' ? 'success' : 'fail';
            var errorMessage = status === 'fail' ? invoice.status : '';
            return __assign({}, invoice, { status: status,
                errorMessage: errorMessage });
        });
    }
    return SubscriptionInvoiceHistoryTable;
}());
angular.module('animatronApp.SubscriptionInvoiceHistoryTable', [])
    .component('subscriptionInvoiceHistoryTable', {
    bindings: {
        invoicesList: '<'
    },
    controller: SubscriptionInvoiceHistoryTable,
    templateUrl: __webpack_require__("H4F6")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/55-bd880478516a225297ea.min.js